import api from './config';

export interface DeveloperFeedback {
  id: string;
  title: string;
  feedback: string;
  user_email: string;
  image_url?: string;
  created_at: string;
  status: 'pending' | 'reviewed' | 'implemented' | 'rejected';
}

export interface CreateDeveloperFeedbackRequest {
  title: string;
  feedback: string;
  user_email: string;
  image?: File;
}

export interface DeveloperFeedbackResponse {
  data: DeveloperFeedback[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const developerFeedbackService = {
  async getFeedback(page: number = 1, limit: number = 10, userEmail?: string): Promise<DeveloperFeedbackResponse> {
    const response = await api.get<DeveloperFeedbackResponse>('/developer-feedback', {
      params: { 
        page, 
        limit,
        user_email: userEmail 
      }
    });
    return response.data;
  },

  async createFeedback(data: FormData): Promise<DeveloperFeedback> {
    const response = await api.post<DeveloperFeedback>('/developer-feedback', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async getFeedbackById(id: string): Promise<DeveloperFeedback> {
    const response = await api.get<DeveloperFeedback>(`/developer-feedback/${id}`);
    return response.data;
  },

  async updateFeedbackStatus(id: string, status: DeveloperFeedback['status']): Promise<DeveloperFeedback> {
    const response = await api.patch<DeveloperFeedback>(`/developer-feedback/${id}`, { status });
    return response.data;
  },

  async deleteFeedback(id: string): Promise<void> {
    await api.delete(`/developer-feedback/${id}`);
  }
}; 